export enum WIDGET_NAMES {
    QUICK_DEPOSIT = 'quickDeposit',
    BALANCE = 'balance',
    INBOX = 'inbox'
}
